export default __webpack_public_path__ + "static/media/app_store.68840c5c.svg";